
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(5839|8318)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
